import { Box, Divider, IconButton, TextField, Typography } from '@mui/material';
import { useBridget } from './hooks';
import { BridgetHeader, ChatEntry, ChatToggleButton } from './components';
import SendIcon from '@mui/icons-material/Send';
import { t } from 'i18next';
import { useDrawerStore } from 'store/drawer.store';
import { theme } from '@store';

export const Bridget = () => {
  const {
    isBridgetOpen,
    isBridgetTyping,
    handleCloseBridget,
    handleToggleBridget,
    handleChangeDraftMessage,
    handleSendMessage,
    isSendDisabled,
    chatEntries,
    handleOnTextfieldKeyDown,
    draftMessage,
    chatEndRef,
    maxMessageLength,
    linkifyOptions,
    inputRef,
    helperTextMessage,
  } = useBridget();

  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  return (
    <>
      <ChatToggleButton
        isOpen={isBridgetOpen}
        handleToggle={handleToggleBridget}
      />

      {isBridgetOpen && (
        <Box
          sx={{
            position: 'absolute',
            right: isDrawerOpen ? 640 : 40,
            bottom: 64,
            bgcolor: theme => theme.palette.common.white,
            zIndex: 100000,
            boxShadow: '0 0 8px 3px rgba(0, 0, 0, 0.2)',
            animation: 'appear .2s linear',
          }}
        >
          <Box
            sx={{
              width: '400px',
              height: '50%',
              maxHeight: '800px',
              pointerEvents: 'all',
            }}
          >
            <BridgetHeader handleClose={handleCloseBridget} />
            {/* {showBanner && (
              <StatusBanner
                text={t('bridget.warning')}
                variant='warning'
                noBottomMargin
                textFontSize='0.85rem'
                closeAction={handleCloseBanner}
              />
            )} */}
            <Divider
              orientation='horizontal'
              sx={{ color: theme.palette.semiBlack.main }}
            />

            {/* Body */}
            <Box
              sx={{
                width: '100%',
                height: '100%',
                bgcolor: theme.palette.grey[50],
                p: '1.5rem',
                pb: '0.5rem',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  maxHeight: '400px',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                  },
                  '&:hover::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                {chatEntries.map((entry, index) => (
                  <ChatEntry
                    linkifyOptions={linkifyOptions}
                    key={`${entry.message}-${index}`}
                    {...entry}
                  />
                ))}
                {isBridgetTyping && (
                  <ChatEntry
                    linkifyOptions={linkifyOptions}
                    isBridgetTyping
                    message=''
                    isOwnMessage={false}
                  />
                )}
                {/* Empty container used for auto scrolling to bottom */}
                <Box ref={chatEndRef} />
              </Box>

              <Typography
                variant='body2'
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  color: theme => theme.palette.semiBlack.main,
                  pt: '0.5rem',
                }}
              >
                {t('bridget.loggingDisclaimer')}
              </Typography>
            </Box>

            <Divider
              orientation='horizontal'
              sx={{ color: theme.palette.semiBlack.main }}
            />

            {/* Footer */}
            <Box
              sx={{
                py: '1rem',
                px: '1.5rem',
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '0.5rem',
              }}
            >
              <TextField
                label={t('bridget.newMessage')}
                fullWidth
                multiline
                inputRef={inputRef}
                maxRows={3}
                variant='outlined'
                onChange={handleChangeDraftMessage}
                onKeyDown={handleOnTextfieldKeyDown}
                disabled={isBridgetTyping}
                value={draftMessage}
                error={draftMessage.length > maxMessageLength}
                helperText={
                  draftMessage.length > maxMessageLength
                    ? t('bridget.toLongMessageError')
                    : helperTextMessage
                }
                slotProps={{
                  formHelperText: {
                    style: {
                      textAlign:
                        draftMessage.length > maxMessageLength
                          ? 'left'
                          : 'right',
                    },
                  },
                }}
              />
              <IconButton
                sx={{ height: 'fit-content', mb: '25px' }}
                disabled={isSendDisabled}
                onClick={handleSendMessage}
              >
                <SendIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
